<template>
  <!--  :class="classObj" -->
  <div class="app-wrapper">
    <el-header style="height: 100px">
      <Navbar />
      <div class="webclass" v-if="isweb">
        <Sidebar class="sidebar-container" />
      </div>
      <div class="nav_right">
        <div class="nav_user">
          <div class="nav_name">{{ this.$store.state.user.name ? this.$store.state.user.name : "admin" }}</div>
          <div class="nav_lagout" @click="logout">
            <i class="el-icon-switch-button" style=" margin-right: 3px"></i>
          </div>
        </div>
      </div>
    </el-header>
    <el-main>
      <div class="noweb" v-if="!isweb">
        <Sidebar class="sidebar-container" />
      </div>
      <router-view></router-view>
      
    </el-main>
    <el-footer>
      <div class="login-footer">
        <span>版权所有：宝鸡市生态环境局</span>
        <span>技术支持：中遥环境（西安）股份有限公司</span>
      </div>
    </el-footer>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
// import ResizeMixin from './mixin/ResizeHandler'
import {
  mapGetters
} from "vuex";
export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
    // TagsView
  },
  data() {
    return {
      isweb: true,
    }
  },
  // mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    // classObj() {
    //   return {
    //     hideSidebar: !this.sidebar.opened,
    //     openSidebar: this.sidebar.opened,
    //     withoutAnimation: this.sidebar.withoutAnimation,
    //     mobile: this.device === "mobile",
    //   };
    // },
  },
  mounted() {
    //浏览器放大缩小事件
    this.$nextTick(() => {
      this.resizeFun();
      // this.resizeFun窗口变化执行的方法
      window.addEventListener("resize", this.resizeFun);
      let screenWidth = document.body.clientWidth;
      let screenHeight = document.body.clientHeight;
      if (screenWidth < 1100) {
        this.isweb = false
      } else {
        this.isweb = true
      }
    });
  },
  methods: {
    resizeFun() {
      // 窗口变化执行的操作
      var screenWidth = window.innerWidth;
      if (screenWidth < 1100) {
        this.isweb = false
      } else {
        this.isweb = true
      }
    },
    handleClickOutside() {
      this.$store.dispatch("closeSideBar", {
        withoutAnimation: false,
      });
    },
    logout() {
      // this.$router.push("/login");
      this.$confirm("确认退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store
            .dispatch("LogOut")
            .then(() => {
              this.$router.push("/");
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="less" scoped>
.nav_right {
  width: 100px;
  height: 100%;
  line-height: 100px;


  .nav_user {
    //   flex: 1;
    margin-right: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    color: #064FBD;
    font-size: 15px;

    .nav_lagout {
      margin-left: 10px;
      cursor: pointer;
    }
  }
}

.login-footer {
  // position: absolute;
  // bottom: 10px;
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  span {
    margin: 0 10px;
  }
}

@media (max-width:500px) {
  .nav_right {
    width: 40px;
    line-height: 45px;

    .nav_user {
      margin-right: 0px;
    }
  }
  /deep/.el-footer{
  height: 60px !important;
}
  .login-footer {
    // height: auto;
    // bottom: 0px;
    // background-color: #fff;
  }
}
</style>
<style lang="less">
.app-wrapper {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.el-header {
  width: 100%;
  margin-bottom: 10px;
  background-color: #fff;
  border-bottom: 4px solid #0061AE;
  flex-shrink: 0;
  padding: 0 !important;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.webclass {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.el-footer{
  height: 30px !important;
}
.sidebar-container {
  /* flex: 1; */
  /* position: absolute;
  top: 0;
  left: 9rem; */
}

.el-main {
  padding: 0 !important;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.el-submenu__title {
  text-align: center;
  padding-left: 0px;
  letter-spacing: 3px;
  font-size: 14px;
}

.el-menu-item {
  text-align: center;
  letter-spacing: 3px;
  font-size: 14px;
  padding: 0 !important;
}

@media (max-width:500px) {
  .el-header {
    height: 50px !important;
    justify-content: space-between;
    align-items: center;
  }

  .noweb {
    width: 100%;
    height: 40px;
    /* display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center; */
  }

}
</style>
